import { createClient } from "@supabase/supabase-js";

// CHỈ 2 biến công khai được — anon key không nói "được đọc gì", RLS mới quyết định (xem docs/RUNBOOK_P0.md).
// service_role KHÔNG BAO GIỜ ở đây hay trong bất kỳ biến VITE_* nào.
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Lỗi rõ ràng lúc dev thay vì lỗi khó hiểu sâu trong supabase-js.
  // eslint-disable-next-line no-console
  console.error(
    "Thiếu VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY — xem .env.example",
  );
}

export const supabase = createClient(url ?? "", anonKey ?? "", {
  auth: {
    flowType: "pkce",
    persistSession: true,
    autoRefreshToken: true,
  },
});
